import * as Yup from "yup";

export const forgotPasswordSchema = Yup.object().shape({
  email: Yup.string()
    .required("Email is required")
    .max(100, "Email must not exceed 100 characters")
    .test(
      "is-valid-email",
      "Invalid email address",
      (value) => !!value && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)
    ),
});
